var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"return-link disable hover-c-contrast pointer",on:{"click":function($event){return _vm.$router.back()}}},[_c('i',{staticClass:"el-icon-arrow-left"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }